import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addItemToCollection } from "directus/src/operations";
import { toast } from "sonner";
import { invalidateAllQueries } from "utils/utils";

export const useCreatePullRequest = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      return await addItemToCollection("pull_requests", values);
    },

    onSuccess: () => {
      toast.success("Pull request created successfully");
      invalidateAllQueries();
    },

    onError: (error) => {
      toast.error(error.message || "Failed to create pull request");
      console.error(error);
    },
  });
};
